import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { headersResolver } from './modules/core'
import { OpenAPI } from './openapi'

// Initialize OpenAPI configuration
OpenAPI.BASE = import.meta.env.VITE_API_URL
OpenAPI.HEADERS = headersResolver
// Required for the HttpOnly refresh-token cookie to flow on cross-origin /refresh
// requests. Browsers silently drop the cookie without these flags.
OpenAPI.WITH_CREDENTIALS = true
OpenAPI.CREDENTIALS = 'include'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
